import React from 'react';
import ArtifactViewCodeDiffHeader from '~/artifact/components/ArtifactViewCodeDiffHeader';
import ArtifactViewCodeDiffDisplay from '~/artifact/components/ArtifactViewCodeDiffDisplay';
type ArtifactViewMainContentFixInfoHowToFixPackageManagerMavenProps = {
  component: object;
  range: object;
  safeVersion?: string;
  unsafeVersion?: object;
  transitive?: boolean;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManagerMaven: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManagerMavenProps
> = props => {
  let component = props.component,
    range = props.range || {},
    safeVersion = props.safeVersion,
    unsafeVersion =
      props.unsafeVersion ||
      (range.versionRange && range.versionRange.indexOf('-') !== -1
        ? range.versionRange.split('-')[0]
        : ''),
    transitive = props.transitive == undefined ? false : props.transitive;
  if (!transitive) {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="pom.xml" />
        <ArtifactViewCodeDiffDisplay type="normal" text="<dependency>" />
        <ArtifactViewCodeDiffDisplay
          type="normal"
          text={'\u2003\u003CgroupId\u003E' + component.coordinate1 + '\u003C/groupId\u003E'}
        />
        <ArtifactViewCodeDiffDisplay
          type="normal"
          text={'\u2003\u003CartifactId\u003E' + component.coordinate2 + '\u003C/artifactId\u003E'}
        />
        <ArtifactViewCodeDiffDisplay
          type="delete"
          text={'\u2003\u003Cversion\u003E' + unsafeVersion + '\u003C/version\u003E'}
        />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={'\u2003\u003Cversion\u003E' + safeVersion + '\u003C/version\u003E'}
        />
        <ArtifactViewCodeDiffDisplay type="normal" text="</dependency>" />
      </div>
    );
  } else {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="pom.xml" />
        <ArtifactViewCodeDiffDisplay type="add" text="<dependency>" />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={'\u2003\u003CgroupId\u003E' + component.coordinate1 + '\u003C/groupId\u003E'}
        />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={'\u2003\u003CartifactId\u003E' + component.coordinate2 + '\u003C/artifactId\u003E'}
        />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={'\u2003\u003Cversion\u003E' + safeVersion + '\u003C/version\u003E'}
        />
        <ArtifactViewCodeDiffDisplay type="add" text="</dependency>" />
      </div>
    );
  }
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManagerMaven;
